import type { Agent } from '@studio/models/agent';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Manufacturer } from '../manufacturer/manufacturer.jsx';

/** Props for DriverContent component */
interface DriverContentProps {
  agent?: Agent | undefined;
  className?: string;
}

/**
 * DriverContent component for Iris Connection driver settings
 *
 * Displays manufacturer-specific driver configuration and settings
 * for the Iris camera connection.
 */
export const DriverContent = ({ className }: DriverContentProps): ReactElement => {
  return (
    <div className={twMerge('flex flex-col gap-24', className)}>
      <div className='flex flex-col gap-16'>
        <Manufacturer className='w-full' />
      </div>
    </div>
  );
};

DriverContent.displayName = 'DriverContent';
